import BaseExpansionItem from "./BaseExpansionItem.vue";

export default BaseExpansionItem;
